import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SafePipeModule } from "safe-pipe";
import { MaterialModule } from 'src/app/material.module';
import { CommonModule } from '@angular/common';
import { DirectiveModule } from '../directives/directive.module';
import { FooterComponent } from './footer.component';

export const ROOT_TOOLS: any[] = [
    FooterComponent
];

@NgModule({
    declarations:[ROOT_TOOLS],
    imports: [     
        FormsModule,
        ReactiveFormsModule,
        CommonModule,  
        MaterialModule,
        DirectiveModule,
        SafePipeModule
    ],
    exports: [ROOT_TOOLS],
    providers: []
})

export class FooterModule{}